import { createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getEvents: ["payload"],
}, { prefix: "admin_notification_" });

export { Types, Creators };
